import React from 'react'
import { MagentoProductPrices } from 'lib/types'
import { PRODUCT_TYPENAME } from 'lib/core/resources/constants'
import { Default } from './components/Default'
// import { Configurable } from './components/Configurable'
import { ConfigurableRange } from './components/ConfigurableRange'

interface Props {
  extraPrice?: number
  price: MagentoProductPrices
  renderOldPrice?: boolean
  quantity?: number
  type?: string
}

export const ProductPrice = (props: Props) => {
  const { type } = props

  switch (type) {
    case PRODUCT_TYPENAME.CONFIGURABLE: {
      return (
        <ConfigurableRange
          {...props}
        />
      )
    }

    default: {
      return (
        <Default
          {...props}
        />
      )
    }
  }
}

ProductPrice.defaultProps = {
  quantity: 1,
  renderOldPrice: true
}
